var map = {
	"./404/404": "0d48",
	"./404/404.vue": "0d48",
	"./_selfie/Selfie": "feca",
	"./_selfie/Selfie.vue": "feca",
	"./code/Code": "b6cc",
	"./code/Code.vue": "b6cc",
	"./code/img/bg_code.png": "b950",
	"./code/img/code.png": "f369",
	"./home/Home": "5c28",
	"./home/Home.vue": "5c28",
	"./home/img/Arrow-Left.png": "6551",
	"./home/img/bg.jpg": "6d2a",
	"./home/img/check.png": "5c66",
	"./home/img/error.png": "2c7e",
	"./home/img/facebook.png": "c75e",
	"./home/img/nocam.png": "ded0",
	"./home/img/success.png": "58ea",
	"./home/img/video.jpg": "5a3a",
	"./home/video/video.mp4": "c89d",
	"./map/Map": "ac36",
	"./map/Map.vue": "ac36",
	"./map/img/_map_en_chicoutimi.jpg": "f015",
	"./map/img/_map_en_montreal.jpg": "f813",
	"./map/img/_map_fr_chicoutimi.jpg": "7b61",
	"./map/img/_map_fr_montreal.jpg": "c2b9",
	"./map/img/btn_code.png": "aff7",
	"./map/img/btn_facebook.png": "63d4",
	"./map/img/btn_instruction.png": "0783",
	"./map/img/btn_selfie.png": "93a9",
	"./map/img/info.png": "8796",
	"./map/img/map_en.jpg": "8c7b",
	"./map/img/map_fr.jpg": "6c48",
	"./map/img/selfie.png": "b307",
	"./marker/Marker": "2755",
	"./marker/Marker.vue": "2755",
	"./marker/Marker__8th": "a24e",
	"./marker/Marker__8th.vue": "a24e",
	"./marker/markers/card/Card": "0448",
	"./marker/markers/card/Card.vue": "0448",
	"./marker/markers/card/active.png": "dcc0",
	"./marker/markers/card/capture.png": "5fba",
	"./marker/markers/card/icon_black.png": "b6fc",
	"./marker/markers/card/inactive.png": "6d1a",
	"./marker/markers/card/marker.patt": "a1ee",
	"./marker/markers/crown/Crown": "ff1e",
	"./marker/markers/crown/Crown.vue": "ff1e",
	"./marker/markers/crown/_marker.patt": "ba30",
	"./marker/markers/crown/active.png": "bae1",
	"./marker/markers/crown/capture.png": "1213",
	"./marker/markers/crown/icon_black.png": "83c1",
	"./marker/markers/crown/inactive.png": "1b06",
	"./marker/markers/crown/marker.patt": "5a17",
	"./marker/markers/mrfleur/MrFleur": "0574",
	"./marker/markers/mrfleur/MrFleur.vue": "0574",
	"./marker/markers/mrfleur/active.png": "a34e",
	"./marker/markers/mrfleur/capture.png": "4ac3",
	"./marker/markers/mrfleur/icon_black.png": "96f0",
	"./marker/markers/mrfleur/inactive.png": "148c",
	"./marker/markers/mrfleur/marker.patt": "f4a9",
	"./marker/markers/mrfleur/marker_singer.patt": "02c1",
	"./marker/markers/singer/Singer": "a8bd",
	"./marker/markers/singer/Singer.vue": "a8bd",
	"./marker/markers/singer/active.png": "69ea",
	"./marker/markers/singer/capture.png": "b5db",
	"./marker/markers/singer/icon_black.png": "302a",
	"./marker/markers/singer/inactive.png": "6e76",
	"./marker/markers/singer/marker.patt": "089b",
	"./marker/markers/singer/pallette.png": "7fd5",
	"./marker/markers/singer/video.mp4": "3b4b",
	"./marker/markers/singer/welcome_en.png": "005e",
	"./marker/markers/singer/welcome_fr.png": "76c0",
	"./marker/markers/trone/Trone": "8049",
	"./marker/markers/trone/Trone.vue": "8049",
	"./marker/markers/trone/active.png": "3b74",
	"./marker/markers/trone/capture.png": "a02e",
	"./marker/markers/trone/icon_black.png": "ae54",
	"./marker/markers/trone/inactive.png": "7874",
	"./marker/markers/trone/marker.patt": "2d5a",
	"./selfie/Selfie": "327b",
	"./selfie/Selfie.vue": "327b",
	"./selfie/brfv4/Brfv4_three": "8fbb",
	"./selfie/brfv4/Brfv4_three.js": "8fbb",
	"./selfie/brfv4/Brfv4_webcam": "ab44",
	"./selfie/brfv4/Brfv4_webcam.js": "ab44",
	"./selfie/brfv4/face.glb": "c8bb",
	"./selfie/effects/aristocrat/Aristocrat": "3966",
	"./selfie/effects/aristocrat/Aristocrat.vue": "3966",
	"./selfie/effects/aristocrat/_hat.glb": "4d4c",
	"./selfie/effects/aristocrat/hat.glb": "6dbf",
	"./selfie/effects/aristocrat/nose.glb": "8131",
	"./selfie/effects/feather-mask/FeatherMask": "c890",
	"./selfie/effects/feather-mask/FeatherMask.vue": "c890",
	"./selfie/effects/feather-mask/_mask.glb": "d057",
	"./selfie/effects/feather-mask/mask.glb": "b188",
	"./selfie/effects/feather-mask/mask.png": "5545",
	"./selfie/effects/mrfleur/Mrfleur": "91a7",
	"./selfie/effects/mrfleur/Mrfleur.vue": "91a7",
	"./selfie/effects/mrfleur/_hat.glb": "e900",
	"./selfie/effects/mrfleur/eyebrow.glb": "9027",
	"./selfie/effects/mrfleur/hat.glb": "3b72",
	"./selfie/img/btn_aristocrat.png": "4052",
	"./selfie/img/btn_capture.png": "a1c6",
	"./selfie/img/btn_feathermask.png": "760a",
	"./selfie/img/btn_mrfleur.png": "01ac",
	"./selfie/img/btn_nofx.png": "42c9",
	"./selfie/img/mini_close.png": "80d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d9d";